import Landing from '@/components/Pages/BuildYourDreamBag/Landing'
import { CAMPAIGNS } from '@/constants/campaigns'
import landingContent from '@/constants/contents/bydb/layout/landing.json'
import { DEFAULT_LOCALE } from '@/constants/locales'
import {
  getBydbCampaignDateOverrides,
  getBydbMarketLocale,
} from '@/utils/bydb-market'
import checkCampaign from '@/utils/check-campaign'
import { getIsSsrMobile } from '@/utils/get-is-ssr-mobile'

export default Landing

export const getServerSideProps = async (ctx: GetServerSidePropsContext) => {
  const locale = getBydbMarketLocale(ctx) ?? ctx.params?.locale ?? DEFAULT_LOCALE
  const isOpen = await checkCampaign(
    CAMPAIGNS.BYDB.name,
    getBydbCampaignDateOverrides(locale),
    locale,
  )

  return {
    props: {
      closed: !isOpen,
      locale,
      layout: landingContent[locale as keyof typeof landingContent] ?? null,
      isSsrMobile: getIsSsrMobile(ctx),
    },
  }
}
